import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axiosWithAuth from "../../utils/axiosWithAuth"
import shortid from "shortid"

import "../../styles/Admin.css"

import Banner from "../navigation/Banner"
import NavBarOrder from "../navigation/NavBarOrder"
import AdminOrderItem from "./AdminOrderItem"
import StockModal from "../navigation/StockModal"
import ManagerModal from "../navigation/ManagerModal"
import ManagerRemoveModal from "../navigation/ManagerRemoveModal"
import ManagerEditModal from "../navigation/ManagerEditModal"

import arrow_down_white from "../../images/arrow_down_white.png"
import arrow_up_white from "../../images/arrow_up_white.png"

function Admin({ user }) {
  const [ orders, setOrders ] = useState([])  
  const [ stockModal, setStockModal ] = useState(false)
  const [ managerModal, setManagerModal ] = useState(false)
  const [ managerRemoveModal, setManagerRemoveModal ] = useState(false)
  const [ managerEditModal, setManagerEditModal ] = useState(false)
  const [ showTools, setShowTools ] = useState(false)
  const adminButton = "Back to menu"
  const navigate = useNavigate()

  async function fetchOrders() {
    const fetchedOrders = await axiosWithAuth().get("/order/fetch")
    setOrders(fetchedOrders.data)
  }

  async function expo(o_id) {
    await axiosWithAuth().put(`/order/serve/${o_id}`)
    const activeOrders = orders.filter(value => value.order_id !== o_id)
    setOrders([...activeOrders])
  }

  useEffect (() => {
    const interval = setInterval(() => {
      fetchOrders()
    }, 10000)

    return () => clearInterval(interval)
  }, [])

  useEffect (() => {
    if (user === null || user.data.user.role < 2) {
      navigate("/register")
    }
    
    fetchOrders()    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="order-dining-page-container" >
      <Banner user={user} adminButton={adminButton} />
      <NavBarOrder adminButton={adminButton} />
      
      <div className="ad-page-content-container">
        <div className="order-dining-content-1">
          <h1>Admin - Orders</h1>
        </div>

        <div className="ad-dining-content-2">
          <div className="ad-toolbox-container">
            
              <div className="ad-toolbox-title" onClick={() => setShowTools(!showTools)}>
                <span>Administration Tools</span>

                <div className="m-arrow-container">
                  {!showTools ?
                    <img src={arrow_down_white} alt="Arrow down" /> :
                    <img src={arrow_up_white} alt="Arrow up" />
                  }
                </div>
              </div>

              {showTools ?
                <div className="ad-toolbox">
                  <button className="ad-tool" onClick={() => setStockModal(true)}>Stock</button>
                  {user ?
                    user.data.user.role === 3 ?
                      <>
                        <button className="ad-tool" onClick={(e) => {
                          e.preventDefault()
                          window.open("https://dashboard.stripe.com/payments", "_blank");
                        }}>Refund</button>
                        <button className="ad-tool" onClick={() => setManagerModal(true)}>Add Mngr.</button>
                        <button className="ad-tool" onClick={() => setManagerRemoveModal(true)}>Remove Mngr.</button>
                        <button className="ad-tool" onClick={() => setManagerEditModal(true)}>Edit Mngr.</button>
                      </>
                    : null
                  : null}
                </div>
              : null}

          </div>

          {orders.length !== 0 ?
            orders.map(item => {
              return <AdminOrderItem item={item} expo={expo} key={shortid.generate()} />
            }) : 
            <div className="ad-no-orders-container">
              <span>No current orders</span>
            </div>
          }
        </div>
      </div>

      {stockModal ?
        <StockModal onClose={() => setStockModal(false)} />
      : null}

      {managerModal ?
        <ManagerModal onClose={() => setManagerModal(false)} />
      : null}

      {managerRemoveModal ?
        <ManagerRemoveModal onClose={() => setManagerRemoveModal(false)} />
      : null}

      {managerEditModal ?
        <ManagerEditModal onClose={() => setManagerEditModal(false)} />
      : null}

    </div>
  )
}

export default Admin
